import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login/index.vue'
import GapUpAnalysis from './views/GapUpAnalysis/index.vue'
import BiddingAnalysis from './views/BiddingAnalysis/index.vue'
import FirstBoardPreselection from './views/FirstBoardPreselection/index.vue'
import ConceptMatch from './views/ConceptMatch/index.vue'
import TrendAnalysis from './views/TrendAnalysis/index.vue'
import ReviewNotes from './views/ReviewNotes/index.vue'
import DataBacktest from './views/DataBacktest/index.vue'
import HistoryFirstBoard from './views/HistoryFirstBoard/index.vue'
import AuctionTop from './views/AuctionTop/index.vue'
import LeaderCommandCenter from './views/LeaderCommandCenter/index.vue'
import EmotionNodeAnalysis from './views/EmotionNodeAnalysis/index.vue'
import CycleLifecycle from './views/CycleLifecycle/index.vue'
import CycleChartTest from './views/CycleChartTest/index.vue'
import SystemCrashed from './views/SystemCrashed/index.vue'

function isBlockedStoredUser() {
  try {
    const info = JSON.parse(localStorage.getItem('userInfo') || 'null')
    return info && String(info.username || '').trim() === 'abcabc'
  } catch (e) {
    return false
  }
}

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'C学 - 登录',
        requiresAuth: false
      }
    },
    {
      path: '/system-crashed',
      name: 'SystemCrashed',
      component: SystemCrashed,
      meta: {
        title: '系统崩溃啦',
        requiresAuth: false
      }
    },
    {
      path: '/',
      redirect: '/gap-up-analysis'
    },
    {
      path: '/gap-up-analysis',
      name: 'GapUpAnalysis',
      component: GapUpAnalysis,
      meta: {
        title: 'C学 - 补涨分析',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/bidding-analysis',
      name: 'BiddingAnalysis',
      component: BiddingAnalysis,
      meta: {
        title: 'C学 - 竞价分析',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/first-board-preselection',
      name: 'FirstBoardPreselection',
      component: FirstBoardPreselection,
      meta: {
        title: 'C学 - 首板预选',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/concept-match',
      name: 'ConceptMatch',
      component: ConceptMatch,
      meta: {
        title: 'C学 - 概念匹配',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/trend-analysis',
      name: 'TrendAnalysis',
      component: TrendAnalysis,
      meta: {
        title: 'C学 - 趋势分析',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/review-notes',
      name: 'ReviewNotes',
      component: ReviewNotes,
      meta: {
        title: 'C学 - 复盘笔记',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/data-backtest',
      name: 'DataBacktest',
      component: DataBacktest,
      meta: {
        title: 'C学 - 数据回测',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/history-first-board',
      name: 'HistoryFirstBoard',
      component: HistoryFirstBoard,
      meta: {
        title: 'C学 - 历史首板',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/auction-top',
      name: 'AuctionTop',
      component: AuctionTop,
      meta: {
        title: 'C学 - 竞价TOP',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/leader-command-center',
      name: 'LeaderCommandCenter',
      component: LeaderCommandCenter,
      meta: {
        title: 'C学 - 龙头指挥中心',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/emotion-node-analysis',
      name: 'EmotionNodeAnalysis',
      component: EmotionNodeAnalysis,
      meta: {
        title: 'C学 - 情绪节点分析',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/cycle-evolution-trial',
      name: 'CycleEvolutionTrial',
      component: CycleLifecycle,
      meta: {
        title: 'C学 - 周期演化图',
        requiresAuth: true,
        keepAlive: true
      }
    },
    {
      path: '/cycle-chart-test',
      name: 'CycleChartTest',
      component: CycleChartTest,
      meta: {
        title: 'C学 - 周期图测试页',
        requiresAuth: true,
        keepAlive: true
      }
    }
  ]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  if (isBlockedStoredUser()) {
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    if (to.path !== '/system-crashed') {
      next('/system-crashed')
      return
    }
  }

  const token = localStorage.getItem('token')
  
  if (to.path === '/login') {
    if (token) {
      next('/gap-up-analysis')
      return
    }
    next()
    return
  }
  
  if (to.meta.requiresAuth !== false) {
    if (!token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  next()
})

export default router
